export default __webpack_public_path__ + "static/media/photo_add.a3b063ee.svg";